import { AmbientLight, DirectionalLight, Group, HemisphereLight } from "three";
import { Wall } from "../domain";
import { directionalPosition } from "./directionalPosition";
import { gammaCorrect } from "./gammaCorrect";
import { optimizeDirectionalShadow } from "./optimizeDirectionalShadow";

export const makeMainLights = (alt: number, az: number, walls: Wall[])
    : Group =>
{
    var result = new Group();
    var mainLight = new DirectionalLight(0xFFFFFF, 2.5);
    mainLight.castShadow = true;

    // these are default values that should be overridden by the call to
    // optimizeDirectionalShadow().
    mainLight.shadow.camera.near = 1;
    mainLight.shadow.camera.far = 350;
    mainLight.shadow.camera.right = 300;
    mainLight.shadow.camera.left = -300;
    mainLight.shadow.camera.top = 300;
    mainLight.shadow.camera.bottom = -300;
    mainLight.shadow.mapSize.width = 4096;
    mainLight.shadow.mapSize.height = 4096;
    mainLight.shadow.camera.updateWorldMatrix(true, false);
    mainLight.target.updateWorldMatrix(true, false);

    directionalPosition(mainLight, alt, az);
//    optimizeDirectionalShadow(mainLight, walls);

    const sphere = optimizeDirectionalShadow(mainLight, walls);

    result.add(mainLight);

    const hemi = new HemisphereLight(
        gammaCorrect(0xFFFFFF), // zenith
        gammaCorrect(0x000000), // ground
        Math.PI/3);
    directionalPosition(hemi, alt, az);
    result.add(hemi);

    var ambient = new AmbientLight(gammaCorrect(0xFFFFFF), Math.PI/3);
    result.add(ambient);

    result.position.copy(sphere.center);
    for(const child of result.children) {
        child.position.sub(sphere.center);
    }
    mainLight.shadow.camera.updateWorldMatrix(true, false);
    mainLight.target.updateWorldMatrix(true, false);

    // DEBUG
//     const 
//         sp = new SphereGeometry(sphere.radius),
//         spedges = new EdgesGeometry(sp),
//         segs = new LineSegments(spedges, new LineBasicMaterial({color: 0xFF0000}));
//     result.add(segs); 

    return result;
};

export default makeMainLights;
